<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
import Index from './views/message_choose.vue'

export default {
  name: 'app',
  components: {
    Index
  },
  methods: {
    setBackground(){
      document.body.style.background = "#666666"
    }
  },
  mounted(){
    this.setBackground()
  }
}
</script>

<style>
#app {
  width:100%;
  height:100%;
}
</style>
